export default __webpack_public_path__ + "static/media/pending-state.195718d0.gif";